// Displays validation error message below a field
export interface FieldErrorProps {
  message?: string;
}

export function FieldError({ message }: FieldErrorProps) {
  if (!message) return null;

  // whitespace-normal: DaisyUI's .label is nowrap, so long messages overflowed the field.
  return (
    <label className="label py-1 whitespace-normal">
      <span className="label-text-alt text-error">{message}</span>
    </label>
  );
}
